import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurrentTimeService implements OnDestroy {
  public time$: Observable<Date>;
  private timeSubject: BehaviorSubject<Date>;
  private clockStarted = false;
  private clockIntervalId = null;

  constructor() {
    this.timeSubject = new BehaviorSubject<Date>(new Date());
    this.time$ = this.timeSubject.asObservable();

    if (!this.clockStarted) {
      this.setupClock();
    }
  }

  set setInitialTime(newTime: Date) {
    if (this.clockStarted === false) {
      this.time = newTime;

      this.clockStarted = true;
      this.clockIntervalId = setInterval(() => {
        this.time = new Date(this.time.getTime() + 1000);
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    // Clears the interval in the browser (memory clean-up)
    clearInterval(this.clockIntervalId);
  }

  public get time(): Date {
    return this.timeSubject.getValue();
  }

  public set time(t: Date) {
    this.timeSubject.next(t);
  }

  private setupClock(): void {
    this.setInitialTime = new Date();
    // this.setupClockInterval = setInterval(() => {
    //   const currentTimeValue = this.timeValue;
    //   const newTimeValue = new Date();
    //
    //   const isOneSecondOut =
    //     Math.abs(
    //       (newTimeValue.getTime() - currentTimeValue.getTime()) / 1000
    //     ) >= 1;
    //
    //   if (isOneSecondOut) {
    //     clearInterval(this.setupClockInterval);
    //     this.setTime = newTimeValue;
    //   }
    // }, 100);
  }
}
